export { OrbitStoreWeb as default } from "./orbitStoreWeb.js";
